 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		13: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		13: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","2":"540d368284c0309328fe6a69263f055ac68e7a9d","3":"e387dfac7ff331721e462b4a421847c6f5f025eb","4":"3eb24a4b85134b6d89f111f6f8cb3f720e63cdfb","5":"b840e4a0e0ec3abd82f448852459c0af2b1f0c75","6":"45b8fa8f769eeaf30dce263ad16a43012959eb36","7":"8cb571fb712555b5543ea31367cbc028f1f27102","8":"b09b495f129397ad93099bc92dc172adf397a53f","9":"7490bd49aa53622910970b252a264e0dd9ced745","10":"c8f7fe3b0e41be846d5687592cf2018ff6e22687","11":"f9beb1971ea41977cd67fb00c0ea9bc6705181bd","12":"fd113b4cd44afc312952b5152606df4c80fa1a9f","15":"7d59d357","17":"b778622a","18":"component---src-pages-404-jsx","19":"component---src-pages-about-jsx","20":"component---src-pages-accessibility-index-jsx","21":"component---src-pages-accessibility-statement-jsx","22":"component---src-pages-accolades-jsx","23":"component---src-pages-alternative-index-jsx","24":"component---src-pages-black-friday-dear-manager-jsx","25":"component---src-pages-black-friday-index-jsx","26":"component---src-pages-calculator-jsx","27":"component---src-pages-case-studies-jsx","28":"component---src-pages-cheatsheets-jsx","29":"component---src-pages-color-contrast-jsx","30":"component---src-pages-css-3-d-transform-examples-index-jsx","31":"component---src-pages-css-specificity-calculator-jsx","32":"component---src-pages-dear-manager-jsx","33":"component---src-pages-disclaimer-jsx","34":"component---src-pages-docs-changelog-jsx","35":"component---src-pages-docs-faq-jsx","36":"component---src-pages-docs-index-jsx","37":"component---src-pages-download-jsx","38":"component---src-pages-experimental-web-platform-features-jsx","39":"component---src-pages-exported-panes-jsx","40":"component---src-pages-for-llms-jsx","41":"component---src-pages-form-inspector-index-jsx","42":"component---src-pages-github-students-jsx","43":"component---src-pages-index-jsx","44":"component---src-pages-integrations-beinclusive-jsx","45":"component---src-pages-integrations-index-jsx","46":"component---src-pages-integrations-jetbrains-webstorm-jsx","47":"component---src-pages-integrations-markerio-jsx","48":"component---src-pages-integrations-toybox-systems-jsx","49":"component---src-pages-integrations-tumult-hype-jsx","50":"component---src-pages-integrations-tumult-whisk-jsx","51":"component---src-pages-legal-jsx","52":"component---src-pages-newsletter-jsx","53":"component---src-pages-opener-jsx","54":"component---src-pages-portal-index-jsx","55":"component---src-pages-pricing-index-jsx","56":"component---src-pages-pricing-quote-jsx","57":"component---src-pages-privacy-jsx","58":"component---src-pages-product-tour-jsx","59":"component---src-pages-quality-assurance-index-jsx","60":"component---src-pages-resources-jsx","61":"component---src-pages-screenshot-comparison-jsx","62":"component---src-pages-site-quality-index-jsx","63":"component---src-pages-snippets-index-jsx","64":"component---src-pages-social-media-previews-index-jsx","65":"component---src-pages-special-offers-jsx","66":"component---src-pages-support-index-jsx","67":"component---src-pages-syntax-jsx","68":"component---src-pages-tailwindcss-jsx","69":"component---src-pages-testimonials-jsx","70":"component---src-pages-thanks-jsx","71":"component---src-templates-blog-list-jsx","72":"component---src-templates-doc-jsx","73":"component---src-templates-post-jsx"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"6e4350186e7153148cec","2":"9a5f1eb84ed3449c390c","3":"2a85c79bc6ea8e810014","4":"9e27ac91ea55ee6037b6","5":"b85dd307d3d4e7883d95","6":"1cd565012fd88f2bcf45","7":"c4984b513df12a08eb2f","8":"2553e110bc55aabb2240","9":"5cd19b71b0aa4a60f500","10":"8ffff841599a0932287c","11":"02ecbe30ecbdd3e06262","12":"8d06d3774ac01475a1df","14":"fb4ef28e65fd79ddb4b8","15":"3865cfce44588362b5ef","17":"86f481f1bf3b7c93ea20","18":"fe2106fba369472a02b0","19":"cf36820e8a5ef3b4e6b9","20":"54c497b11fb9a8d4f492","21":"0a07b59ec09f902ac616","22":"42f99c5295f369bc93c3","23":"6227319d7510429bd10d","24":"d2b6ad06fead3e644074","25":"dea107bc10253b680f42","26":"516f5c16e0ca044380b4","27":"62dd8b33f202b89aa3d1","28":"eac777ea5e376924fd72","29":"98a280887fad19cd63d6","30":"6f4aaff3d2745bbee11b","31":"5223a5a0eb256a94136d","32":"7db57909bc7d53f07d4d","33":"0ba02d0d2b15251a91a9","34":"46f00cfc4e3367d39171","35":"1d681f22efd8d15caccd","36":"4dfe5ccfaa77bc3b63fd","37":"51655a4c9b9968a5e80c","38":"fe68db24ee33aeb364cb","39":"1a44250223e5db52e780","40":"94cd50e0c4f470f3c5d0","41":"3042656032966cb14891","42":"c32e0eda60c6230339cc","43":"4cbe30e2f07922b7f164","44":"670f39570ec59b034866","45":"1c28b988de39b74fe476","46":"edec52389033d23f9193","47":"16875c14fef8a68198c1","48":"f64f1ed1bbec9192e869","49":"b5352f483651a4d30ee3","50":"7ea1274e1d209996bdb0","51":"75aaa58ec7cba616b2af","52":"3875eee907d0c78e632b","53":"2b469afd3d3a15933c4c","54":"03f634fee08eb05682a3","55":"b6858989c015e3cd9230","56":"be4aeb840d6cea7541b1","57":"6c8b827e5dd6c19811f7","58":"fa858c664d1697f780ec","59":"ae9553a4b0182df13fab","60":"d16a0eacc5e22d6591b0","61":"7ac76c9f29532e68a158","62":"9ab24acfd0cb88aac159","63":"1cb7477e47ec240317bf","64":"40579c5b356b4293d35b","65":"00eb4ed8d1d77b0889d6","66":"7ad5465b74fe6ea11332","67":"4aadd3e17e39d24c68d1","68":"0e6c65c09e11dc26ce2c","69":"d2e530d19360b7e04502","70":"4f91e747c7d5bd89f5ab","71":"380449dda49572778e7a","72":"6e7aef4a0a2d79329885","73":"40ac4d06a013c0225920","76":"a03c6406cf5295f9e997","77":"4ca8f03f126462f8edae","78":"81a9b05046eda45b5949","79":"2c5fbf4be57872a46b7c","80":"7711f126b2b097364187","81":"39be1c826e4cec0f7c47","82":"5a6e2ad682c1a38dc204","83":"daa66f4743e44f74174a","84":"a42541ccf716a9e65113"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","2":"540d368284c0309328fe6a69263f055ac68e7a9d","3":"e387dfac7ff331721e462b4a421847c6f5f025eb","4":"3eb24a4b85134b6d89f111f6f8cb3f720e63cdfb","5":"b840e4a0e0ec3abd82f448852459c0af2b1f0c75","6":"45b8fa8f769eeaf30dce263ad16a43012959eb36","7":"8cb571fb712555b5543ea31367cbc028f1f27102","8":"b09b495f129397ad93099bc92dc172adf397a53f","9":"7490bd49aa53622910970b252a264e0dd9ced745","10":"c8f7fe3b0e41be846d5687592cf2018ff6e22687","11":"f9beb1971ea41977cd67fb00c0ea9bc6705181bd","12":"fd113b4cd44afc312952b5152606df4c80fa1a9f","15":"7d59d357","17":"b778622a","18":"component---src-pages-404-jsx","19":"component---src-pages-about-jsx","20":"component---src-pages-accessibility-index-jsx","21":"component---src-pages-accessibility-statement-jsx","22":"component---src-pages-accolades-jsx","23":"component---src-pages-alternative-index-jsx","24":"component---src-pages-black-friday-dear-manager-jsx","25":"component---src-pages-black-friday-index-jsx","26":"component---src-pages-calculator-jsx","27":"component---src-pages-case-studies-jsx","28":"component---src-pages-cheatsheets-jsx","29":"component---src-pages-color-contrast-jsx","30":"component---src-pages-css-3-d-transform-examples-index-jsx","31":"component---src-pages-css-specificity-calculator-jsx","32":"component---src-pages-dear-manager-jsx","33":"component---src-pages-disclaimer-jsx","34":"component---src-pages-docs-changelog-jsx","35":"component---src-pages-docs-faq-jsx","36":"component---src-pages-docs-index-jsx","37":"component---src-pages-download-jsx","38":"component---src-pages-experimental-web-platform-features-jsx","39":"component---src-pages-exported-panes-jsx","40":"component---src-pages-for-llms-jsx","41":"component---src-pages-form-inspector-index-jsx","42":"component---src-pages-github-students-jsx","43":"component---src-pages-index-jsx","44":"component---src-pages-integrations-beinclusive-jsx","45":"component---src-pages-integrations-index-jsx","46":"component---src-pages-integrations-jetbrains-webstorm-jsx","47":"component---src-pages-integrations-markerio-jsx","48":"component---src-pages-integrations-toybox-systems-jsx","49":"component---src-pages-integrations-tumult-hype-jsx","50":"component---src-pages-integrations-tumult-whisk-jsx","51":"component---src-pages-legal-jsx","52":"component---src-pages-newsletter-jsx","53":"component---src-pages-opener-jsx","54":"component---src-pages-portal-index-jsx","55":"component---src-pages-pricing-index-jsx","56":"component---src-pages-pricing-quote-jsx","57":"component---src-pages-privacy-jsx","58":"component---src-pages-product-tour-jsx","59":"component---src-pages-quality-assurance-index-jsx","60":"component---src-pages-resources-jsx","61":"component---src-pages-screenshot-comparison-jsx","62":"component---src-pages-site-quality-index-jsx","63":"component---src-pages-snippets-index-jsx","64":"component---src-pages-social-media-previews-index-jsx","65":"component---src-pages-special-offers-jsx","66":"component---src-pages-support-index-jsx","67":"component---src-pages-syntax-jsx","68":"component---src-pages-tailwindcss-jsx","69":"component---src-pages-testimonials-jsx","70":"component---src-pages-thanks-jsx","71":"component---src-templates-blog-list-jsx","72":"component---src-templates-doc-jsx","73":"component---src-templates-post-jsx"}[chunkId]||chunkId) + "." + {"0":"b8f506cf242498fcaa59","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c","77":"31d6cfe0d16ae931b73c","78":"31d6cfe0d16ae931b73c","79":"31d6cfe0d16ae931b73c","80":"31d6cfe0d16ae931b73c","81":"31d6cfe0d16ae931b73c","82":"31d6cfe0d16ae931b73c","83":"31d6cfe0d16ae931b73c","84":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
